import { atom, useAtomValue, useSetAtom } from 'jotai';
import { CJEvent } from 'types/event';

const createFicheDePrepDrawerAtom = atom<CJEvent | undefined>(undefined);

export const useCreateFicheDePrepPayload = () =>
  useAtomValue(createFicheDePrepDrawerAtom);
const closeAtom = atom(null, (get, set) =>
  set(createFicheDePrepDrawerAtom, undefined),
);
export const useCloseCreateFicheDePrepDrawer = () => useSetAtom(closeAtom);
export const useOpenCreateFicheDePrepDrawer = () =>
  useSetAtom(createFicheDePrepDrawerAtom);

const createFicheDePrepInsideModalDrawerAtom = atom<CJEvent | undefined>(
  undefined,
);
export const useCreateFicheDePrepInsideModalPayload = () =>
  useAtomValue(createFicheDePrepInsideModalDrawerAtom);
const closeInsideModalAtom = atom(null, (get, set) =>
  set(createFicheDePrepInsideModalDrawerAtom, undefined),
);
export const useCloseCreateFicheDePrepInsideModalDrawer = () =>
  useSetAtom(closeInsideModalAtom);
export const useOpenCreateFicheDePrepInsideModalDrawer = () =>
  useSetAtom(createFicheDePrepInsideModalDrawerAtom);
